import { createApi } from '../../../shared/redux/createApi';

export const complianceApi = createApi({
  reducerPath: 'complianceApi',
  tagTypes: ['Compliance'],
  endpoints: (builder) => ({
    checkCompliance: builder.mutation({
      query: ({ first_name, last_name, birth_date }) => {
        const params = new URLSearchParams();
        if (first_name) params.append('first_name', first_name);
        if (last_name) params.append('last_name', last_name);
        if (birth_date) params.append('birth_date', birth_date);
        
        return {
          url: `/compliance-module/check-user-compliance?${params.toString()}`,
          method: 'GET',
        };
      },
      invalidatesTags: ['Compliance'],
    }),
    getComplianceList: builder.query({
      query: ({ page = 1, limit = 10 }) => ({
        url: `/compliance-module/compliance-user/list?page=${page}&limit=${limit}`,
        method: 'GET',
      }),
      providesTags: ['Compliance'],
    }),
  }),
});

export const { 
  useCheckComplianceMutation, 
  useGetComplianceListQuery 
} = complianceApi;